export const isMobile = window.innerWidth < 768;
export const s3url = process.env.REACT_APP_S3_URL;

// headerConfig.js
export const headerConfig = {
  "/": {
    type: "demo", // shows Book a Demo
    scroll_to: "book-a-demo",
  },
  "/billing&refunds": {
    type: "",
    scroll_to: "",
  },
  "/term&condition": {
    type: "",
    scroll_to: "",
  },
  // "/bounce-proof": {
  //   type: "auth",
  //   redirect_url: "https://tryatgff.bounceproof.co/",
  // },
  // "/tamper-proof": {
  //   type: "auth",
  //   redirect_url: "https://tryatgff.tamperproof.co/",
  // },
};
